export const SongLists = {
  title: [
    "공부 시작할 때 듣는 playlists",
    "새벽에 코딩할 때 듣는 playlists",
    "코딩하다 화날 때 듣는 playlists",
    "코딩하다 늘어질 때 듣는 playlists",
    "새벽에 코딩할 때 듣는 playlists2",
    "코딩하다 진짜 더 화날 때 듣는 playlists",
    "다른 공부할 때 듣는 playlists",
    "제출 10분 남았을 때 듣는 playlists",
  ],
  iframe: [
    "https://www.youtube.com/embed/U9jGfrOeGoI?si=DadeEh26z5r0OBWU",
    "https://www.youtube.com/embed/ZR9a-QMQhM8?si=a32U5lNchqcnl2Td",
    "https://www.youtube.com/embed/Fh5AE3sdmWQ?si=H3vR4cmLLO8sslAQ",
    "https://www.youtube.com/embed/ab_NBkqE9qc?si=ELcA_3zpegsgjmvT",
    "https://www.youtube.com/embed/PT25tQOshCk?si=j6jZ7AiSK-Da5z3v",
    "https://www.youtube.com/embed/pwHTwddXcPo?si=qMYtoH-hUJm5Qku3",
    "https://www.youtube.com/embed/07cEAO9wgCc?si=EChgsTgz8V_RVPdb",
    "https://www.youtube.com/embed/gWNhGnQfRFM?si=K81phEhyQXqCbqZ4",
  ],
};
